import { useCallback, useEffect, useState, useRef } from 'react';
import {
  Checkbox, Container,
  Stack,
  Typography,
  CircularProgress,
  OutlinedInput,
  InputAdornment,
  Toolbar,
  Box,
  Card, Popper,
  Autocomplete,
  TextField, Paper,
  Chip,
  Button,
  createFilterOptions,
  FormControl,
  Grid,
  InputLabel, Select, MenuItem,
  Breadcrumbs, Link, Divider
} from '@mui/material';
// components
import Page from '../components/Page';
import DashboardBreadcrumbLink from 'src/components/DashboardBreadcrumbLink';
import { AuditList } from '../sections/auditlist';
// mock
import { styled, alpha, useTheme } from '@mui/material/styles';
import useAuditList from 'src/api/useAuditList';
import Iconify from 'src/components/Iconify';
import { useNavigate } from 'react-router-dom';

import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { format } from 'date-fns';
import DeleteIcon from '@mui/icons-material/Delete';
import NotificationAlert from 'src/utils/NotificationAlert';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { renderTimeViewClock } from '@mui/x-date-pickers/timeViewRenderers';

import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import dayjs from 'dayjs';
import * as XLSX from 'xlsx';
import RedoIcon from '@mui/icons-material/Redo';
import { getClientGroupInfo } from 'src/api/liveCameras';
import { useLocation } from 'react-router-dom';
import { AuditPlayer } from 'src/sections/@dashboard/audit';
import { getDashboardEventSummary } from 'src/api/clientDetails';
import { siteTypeParam } from 'src/utils/siteType';
import useSiteType from 'src/hooks/useSiteType';
import DateDisplay from './datefields';
import { getClientCameras } from 'src/api/clientDetails';
import FilterListIcon from '@mui/icons-material/FilterList';
import { Tooltip, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { getCurrentClientNow } from 'src/utils/clientTime';
import { parseAuditDate, selectAuditSummary } from 'src/utils/auditFilters';

import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import { getClientLocations } from 'src/api/ShiftMaster';
import { getAppStorageItem } from 'src/utils/storageProxy';


const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const groupicon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const groupcheckedIcon = <CheckBoxIcon fontSize="small" />;

const getAssignedLocationsFromStorage = () => {
  try {
    const assignedLocationsRaw = getAppStorageItem('assigned_locations');
    if (!assignedLocationsRaw) return [];

    const parsedAssignedLocations = JSON.parse(assignedLocationsRaw);
    const assignedLocations = Array.isArray(parsedAssignedLocations)
      ? parsedAssignedLocations
      : [];

    return assignedLocations
      .map((locationItem) => ({
        ID: Number(locationItem?.ID ?? locationItem?.id ?? 0),
        Location: String(locationItem?.Location || locationItem?.name || '').trim(),
      }))
      .filter((locationItem) => locationItem.ID > 0);
  } catch (error) {
    console.error('Failed to read assigned_locations from storage:', error);
    return [];
  }
};

const EVENT_TYPE_FALLBACK_CLIENT_IDS = ['1427', '1428', '1445'];

const isBlankEventType = (value) => {
  const text = String(value ?? '').trim();
  return text === '' || text.toLowerCase() === 'null';
};

// import CloseIcon from '@mui/icons-material/Close';
// import { useState } from 'react';
// ----------------------------------------------------------------------


const SearchStyle = styled(OutlinedInput)(({ theme }) => ({
  maxWidth: 200,
  transition: theme.transitions.create(['box-shadow', 'width'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
  '&.Mui-focused': { width: 320, boxShadow: theme.customShadows.z8 },
  '& fieldset': {
    borderWidth: `1px !important`,
    borderColor: `${theme.palette.grey[500_32]} !important`,
  },
}));

const CustomBox = styled(Stack)(({ theme }) => ({
  border: `1px dashed rgba(145, 158, 171, 0.16)`,
  padding: theme.spacing(1),
  borderRadius: 8
}));

const RootStyle = styled(Toolbar)(({ theme }) => ({
  height: 96,
  display: 'flex',
  justifyContent: 'space-between',
  // padding: theme.spacing(0, 1, 0, 3),
}));


//Date block css
const ContainerDate = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  // alignItems: 'center',
  justifyContent: "flex-start",
  padding: '10px',
  fontFamily: 'Arial, sans-serif',
  // backgroundColor: '#f5f7fa',
});

const NavButtonContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: "flex-start",
  gap: '10px',
});

const NavButton = styled(Button)(({ theme }) => ({
  minWidth: '26px',
  height: '56px',
  fontSize: '16px',
  fontWeight: 'bold',
  borderRadius: '8px',
  padding: 0,
  color: theme.palette.primary.contrastText,
  backgroundColor: theme.palette.primary.main,
  border: 'none',
  boxShadow: '0 2px 6px rgba(0, 0, 0, 0.1)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '&:hover': {
    backgroundColor: theme.palette.primary.dark,
    transform: 'scale(1.03)',
  },
  '&.Mui-disabled': {
    color: theme.palette.text.disabled,
    backgroundColor: theme.palette.action.disabledBackground,
    cursor: 'not-allowed',
  },
}));

const DateRow = styled(Box)({
  display: 'flex',
  gap: '6px',
  maxWidth: '100%',
  overflowX: 'auto',
  scrollBehavior: 'smooth',
  padding: '4px 0',
  //minWidth:'50%'
});

const DateText = styled('div')({
  fontWeight: 500,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  fontSize: '10px',
  lineHeight: 1.2,
});

const MonthText = styled('div')({
  fontSize: '9px',
  fontWeight: 600,
  opacity: 0.85,
});

const DayNumber = styled('div')({
  fontSize: '14px',
  fontWeight: 'bold',
  margin: '2px 0',
});

const DayText = styled('div')({
  fontSize: '9px',
  // color: '#718096',
});

const DateBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== "dateSelected", // filter out
})(({ dateSelected, theme }) => ({
  border: dateSelected
    ? `2px solid ${alpha(theme.palette.primary.main, 0.7)}`
    : `1px solid ${alpha(theme.palette.text.primary, theme.palette.mode === 'dark' ? 0.35 : 0.2)}`,
  borderRadius: "10px",
  padding: "5px 3px",
  textAlign: "center",
  minWidth: "45px",
  height: "70px",
  boxSizing: "border-box",
  cursor: "pointer",
  backgroundColor: dateSelected ? theme.palette.primary.main : theme.palette.background.paper,
  color: dateSelected ? theme.palette.primary.contrastText : theme.palette.text.primary,
  fontSize: "0.65rem",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  boxShadow: dateSelected
    ? `0 2px 8px ${alpha(theme.palette.primary.main, 0.3)}`
    : `0 1px 3px ${alpha(theme.palette.common.black, theme.palette.mode === 'dark' ? 0.4 : 0.08)}`,
  transition: "all 0.2s ease-in-out",
  "&:hover": {
    transform: "translateY(-3px)",
    boxShadow: `0 4px 10px ${alpha(theme.palette.primary.main, 0.2)}`,
  },
}));


export default function ListAudits({ userType, clientId, IsAgentBased }) {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const UI = {
    inputBg: isDark ? alpha(theme.palette.common.white, 0.06) : theme.palette.background.paper,
    inputText: theme.palette.text.primary,
    inputBorder: alpha(theme.palette.text.primary, isDark ? 0.4 : 0.24),
    chipMutedBg: theme.palette.background.paper,
    chipMutedText: theme.palette.text.primary,
  };



  const location = useLocation();
  const navigate = useNavigate();

  const { filterData } = location.state || {};

  let client_id = 0;
  if(localStorage.getItem('Type') === 'merge'){
    client_id = localStorage.getItem('ID');
  }
  else{
    client_id = localStorage.getItem('client_id');
  }

  const siteType = useSiteType();
  // the real client id: client_id above can hold the merge ID
  const siteTypeClientId = localStorage.getItem('client_id');

  // Use received filter data or fall back to defaults

  const initialFromDate = filterData?.fromDate || null;
  const initialToDate = filterData?.toDate || null;
  const typeDetected = filterData?.eventType || null;
  const initialLocation = filterData?.location_id || null;
  const initialProperty = filterData?.property_id || null;
  const event = filterData?.event || null
  const useDetectedEventTypeFallback = EVENT_TYPE_FALLBACK_CLIENT_IDS.includes(String(client_id));

  const getClientEventType = useCallback((auditEvent = {}) => {
    if (!useDetectedEventTypeFallback) {
      return auditEvent.EventType || '';
    }

    return !isBlankEventType(auditEvent.DetectedEventType)
      ? auditEvent.DetectedEventType
      : auditEvent.DetectedType || '';
  }, [useDetectedEventTypeFallback]);

  const getClientDetectedEventType = useCallback((auditEvent = {}) => {
    if (!useDetectedEventTypeFallback) {
      return auditEvent.DetectedEventType || '';
    }

    return !isBlankEventType(auditEvent.DetectedEventType)
      ? auditEvent.DetectedEventType
      : auditEvent.DetectedType || '';
  }, [useDetectedEventTypeFallback]);

  const buildPlayerEvent = useCallback((auditEvent) => {
    const displayEventType = getClientEventType(auditEvent);
    const detectedEventType = getClientDetectedEventType(auditEvent);

    return {
      Id: auditEvent.EventNo || '',
      DeviceName: auditEvent.devicename,
      CreatedOn: auditEvent.ClientCreatedOn || null,
      VideoUrl: auditEvent.VideoUrl || '',
      DetectedType: useDetectedEventTypeFallback ? displayEventType : auditEvent.DetectedType || '',
      EventNo: auditEvent.EventNo || '',
      display: 'block',
      devicename: auditEvent.devicename || '',
      EventType: useDetectedEventTypeFallback ? displayEventType : auditEvent.EventType || '',
      MainEventType: auditEvent.MainEventType || '',
      CameraId: auditEvent.CameraId || null,
      EventTime: auditEvent.EventTime || null,
      SnapshotUrl: auditEvent.SnapshotUrl || '',
      SupervisorComments: auditEvent.SupervisorComments || '',
      Priority: auditEvent.Priority || 1,
      isOpen: true,
      detectiontype: detectedEventType,
      DetectedEventType: detectedEventType,
      icon: auditEvent.Icon,
    };
  }, [getClientDetectedEventType, getClientEventType, useDetectedEventTypeFallback]);
  //const locationName = filterData?.locationName || null
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [isDateAvail, setIsDateAvail] = useState(false)

  const storedProperty = localStorage.getItem('Location');
  const AssignClient = localStorage.getItem('AssignClient');

  const [locations, setLocations] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState(null);

  const isNavigated = (filterData === null || filterData === undefined) ? false : true;

  const [selectedProperty, setSelectedProperty] = useState(() => {
    const stored = localStorage.getItem('selectedProperty');
    return stored ? parseInt(stored) : null;
  });

  const [properties, setProperties] = useState([]);

  // useEffect(()=>{
  // if(initialFromDate){
  //     const location = localStorage.getItem('selectedLocation')
  //     setSelectedLocation(location)
  //   }
  // },[initialFromDate])


  const [player, setPlayer] = useState({
    isOpen: false,
    event: null,
  });

  const [calculatedDay, setCalculatedDay] = useState(null);

  const [showDialog, setShowDialog] = useState({
    isOpen: false,
    event: null,
  });


  const displayDialog = (val, event) => {
    //setShowDialog(val);
    if (event != null) {
      setShowDialog({
        isOpen: true,
        event: buildPlayerEvent(event),
      });
    } else {
      setPlayer({ isOpen: false, event: null });
    }
  };

  const {
    alldata,
    setSearch,
    loadMoreAudits,
    filterAudits,
    updateToClient,
    isEscalating,
    open,
    setOpen,
    cameras,
    analytics,
    fromDate,
    toDate,
    handleFromDate,
    handleToDate,
    detectedType,
    handleDetectedType,
    device,
    handleDevice,
    handleDelete,
    //calculatedDay,
    handlerGetFilterData,
    alertStatus,
    handleNotificationBar,
    freeData
  } = useAuditList(userType, IsAgentBased, initialFromDate, initialToDate, initialLocation, typeDetected, calculatedDay, initialProperty)

  const clearFilterData = () => {
    navigate(location.pathname, {
      state: { filterData: null },
      replace: true,
    });
  };

  useEffect(() => {
    //
    if (event != null) {
      setPlayer({
        isOpen: true,
        event: buildPlayerEvent(event),
      });
    } else {
      setPlayer({ isOpen: false, event: null });
    }
  }, [buildPlayerEvent, event])

  const agentBased = localStorage.getItem('IsAgentBased')
  // console.log("agent based",agentBased);

  const [selectedDevices, setSelectedDevices] = useState([]);

  const [activeCameras, setActiveCameras] = useState([])

  const [checkValue, setCheckValue] = useState(false)

  const [openAuto, setOpenAuto] = useState(false)


  const [openBuzzerSelect, setOpenBuzzerSelect] = useState(false);
  const [activeBuzzers, setActiveBuzzers] = useState([])

  const [errorTodate, setErrorTodate] = useState('')
  const [errorFromdate, setErrorFromdate] = useState('')
  const [clientGroupList, setClientGroupsList] = useState([]);
  const [groupinfo, setGroupinfo] = useState([]);

  const [errorGroup, setErrorGroup] = useState(null);
  const [groupCheckValue, setGroupCheckValue] = useState(false)
  const [activeGroups, setActiveGroups] = useState([])
  const [camerasByGroupId, setCamerasByGroup] = useState([]);
  const [clientType, setClientType] = useState('');

  const [eventTypes, setEventTypes] = useState([]);
  const [summaryLoading, setSummaryLoading] = useState(false);
  const [summaryError, setSummaryError] = useState('');
  const summaryRequestRef = useRef(0);
  const [eventName, setEventName] = useState('')

  //const [selectedCard, setSelectedCard] = useState('total');
  const [selectedCard, setSelectedCard] = useState(typeDetected || 'total');

  const [isInitialLoad, setIsInitialLoad] = useState(true);


  const handleGroupChange = (event, val) => {
    //
    if (event.target.value && errorGroup) {
      setErrorGroup(null)
    }

    setCheckValue(false)
    const containsAllProperty = val.some(obj => obj.hasOwnProperty('all'));

    if (clientGroupList.length === activeGroups.length && containsAllProperty) {
      setGroupCheckValue(false)
      setActiveGroups([])
      setCheckValue(false)
      setActiveCameras([])
      setCamerasByGroup([])
    }

    else if (containsAllProperty) {
      setGroupCheckValue(true)
      let groupId = clientGroupList.map(val => val.GroupId)
      setActiveGroups(groupId)
    }

    else {
      const grpId = val[0].GroupId
      const avail = activeGroups.length > 0 ? activeGroups.filter(item => item === grpId) : []

      if (avail.length > 0) { // remove the group id
        const id = activeGroups.filter(item => item !== grpId)
        setActiveGroups(id)
        setGroupCheckValue(false)

        if (id.length === 0) {
          setCheckValue(false)
          setActiveCameras([])
          setCamerasByGroup([])
        }
      }
      else { //  add group id
        //setActiveCameras()
        setActiveGroups((id) => [...id, grpId]);

        //[...activeGroups, grpId].length === clientGroupList ? setGroupCheckValue(true) : setGroupCheckValue(false)
      }
    }
  };

  const handleGroupFilterOptions = (options, params) => {
    //
    const filter = createFilterOptions();
    const filtered = filter(options, params);
    //return [{ title: 'Select All', all: true }, ...sortedOptions];
    return [{ title: 'Select All', all: true }, ...filtered];
  };

  useEffect(() => {
    if (activeGroups.length === clientGroupList.length && activeGroups.length > 0) {
      setGroupCheckValue(true)
    }

    if (activeGroups.length > 0) {
      //
      let cams = groupinfo.filter(val => activeGroups.includes(val.GroupId))
      let enrichedDevices = cams.map(groupDevice => {
        let correspondingCamera = cameras.find(camera => camera.deviceid === groupDevice.deviceid);
        if (correspondingCamera) {
          return {
            ...groupDevice,
            uid: correspondingCamera.uid
          };
        }
        return groupDevice;
      });
      setCamerasByGroup(enrichedDevices)
      // console.log(activeCameras)
      const newId = enrichedDevices.map(val => val.uid)
      const filArr = activeCameras.filter(val => newId.includes(val))
      // console.log(filArr)
      setActiveCameras(filArr)

      if (enrichedDevices.length === filArr.length && filArr.length > 0) {
        setCheckValue(true)
      }
    }
  }, [activeGroups])

  useEffect(() => {
    
    let client_id = 0;
    if(localStorage.getItem('Type') === 'merge'){
      client_id = localStorage.getItem('ID');
    }
    else{
      client_id = localStorage.getItem('client_id');
    }
    let clientType = localStorage.getItem('client_type')
    setClientType(clientType)
    let groupId = 0
    let clientGroupData = { clientId: clientId, groupId: groupId }
    getClientGroupInfo(clientGroupData, (response) => {
      if (response.status === 200) {
        // console.log("response Data group ", response.data);
        setGroupinfo(response.data)
        const uniqueGroups = Array.from(
          new Map(response.data.map(item => [item.GroupId, { GroupId: item.GroupId, GroupName: item.GroupName }])).values()
        );
        setClientGroupsList(uniqueGroups);
      }
    });


    if(AssignClient!=='' && storedProperty!=='') {
      const assignedLocations = getAssignedLocationsFromStorage();
      setProperties(assignedLocations);

      const stored = localStorage.getItem('selectedProperty');
      if (stored) {
        const found = assignedLocations.find((loc) => loc.ID === parseInt(stored));
        if (found) {
          setSelectedProperty(found.ID);
        }
      } else {
        const first = assignedLocations[0];
        if (first) {
          setSelectedProperty(first.ID);
          localStorage.setItem('selectedProperty', first.ID);
        }
      }
    }

    const body = { client_id: Number(client_id) }

    getClientLocations(body, (response) => {
      if (response.status === 200) {
        const prev = localStorage.getItem('selectedLocation');
        setLocations(response.data);
        if (response.data.length > 0) {
          if (!initialFromDate && !prev) {
            const firstLocation = response.data[0].Id;
            setSelectedLocation(firstLocation);
            localStorage.setItem('selectedLocation', firstLocation);
          }
          else if (prev) {
            setSelectedLocation(prev);
          }
        }
      }
    });

  }, []);

  const handleCamerasChange = (event, value) => {
    //
    let actCams = [];
    if (value.some(obj => obj.hasOwnProperty('selectall'))) {
      if (activeCameras.length === cameras.length) {
        setActiveCameras([])
        setCheckValue(false)
      }
      else {

        if (clientGroupList.length === 0) {
          cameras.forEach(item => {
            actCams.push(item.uid)
          })
        }
        else {
          let cams = groupinfo.filter(val => activeGroups.includes(val.GroupId))
          let enrichedDevices = cams.map(groupDevice => {
            let correspondingCamera = cameras.find(camera => camera.deviceid === groupDevice.deviceid);
            if (correspondingCamera) {
              return {
                ...groupDevice,
                uid: correspondingCamera.uid
              };
            }
            return groupDevice;
          });
          enrichedDevices.forEach(item => {
            actCams.push(item.uid)
          })
        }

        setActiveCameras(actCams)
        setCheckValue(true)
      }
    }
    else {
      let id = value[0].uid;
      if (activeCameras.includes(id)) {
        let filterArr = activeCameras.filter(devid => devid !== id);
        //console.log(typeof activeClients[0]);
        setActiveCameras(filterArr);
        if (checkValue) {
          setCheckValue(false)
        }
      }
      else {
        setActiveCameras((prv) => [...prv, id])
      }
    }
  };

  useEffect(() => {
    //
    handleDevice('', activeCameras, camerasByGroupId)
    //console.log(activeCameras)
    if ((activeCameras.length === cameras.length && activeCameras.length > 0 && clientGroupList.length === 0) || (activeCameras.length === camerasByGroupId.length && activeCameras.length > 0 && clientGroupList.length > 0)) {
      setCheckValue(true)
    }
  }, [activeCameras])


  const onFilterAudits = (event) => {
    setSearch(event.target.value)
    filterAudits(event.target.value)
  }

  const handleFilterOptions = (options, params) => {
    //
    const filter = createFilterOptions();
    const filtered = filter(options, params);

    // Separate selected and unselected options
    const selectedOptions = filtered.filter(option => activeCameras.includes(option.uid));
    const unselectedOptions = filtered.filter(option => !activeCameras.includes(option.uid));

    // Sort options: selected options first, then unselected
    const sortedOptions = [...selectedOptions, ...unselectedOptions];

    return [{ title: 'Select All', selectall: true }, ...filtered];
  };


  const handleBuzzersChange = (event, value) => {
    // console.log("==BUZZER====",event.target.value, value)
    setActiveBuzzers(value.map((buzzer) => buzzer.uid));
  };

  const handleGet = () => {

    setOpenAuto(false)
    setErrorFromdate('')
    setErrorTodate('')
    // console.log(fromDate,toDate);
    const isValidDate = (dateString) => {
      const parsedDate = dayjs(dateString, 'YYYY-MM-DD HH:mm:ss', true);
      return parsedDate.isValid();
    };

    if (fromDate === null && toDate === null) {
      return;
    }

    const fromdDateObj = isValidDate(fromDate)
    const toDateObj = isValidDate(toDate)

    if (!fromdDateObj) setErrorFromdate('Select Valid From Date')
    if (!toDateObj) setErrorTodate('Select Valid To Date')
    handlerGetFilterData()
  }


  const getCardsData = () => {
    const requestId = ++summaryRequestRef.current;
    const eventCategory = siteTypeParam(siteTypeClientId, siteType);
    const range = getActiveAuditRange();
    if (!range) return;
    const newData = {
      fromdate: range.fromDate,
      todate: range.toDate,
      location_id: range.locationId,
      property_id: range.propertyId,
      ...eventCategory,
    };
    setSummaryLoading(true);
    setSummaryError('');
    getDashboardEventSummary(newData, (response) => {
      if (requestId !== summaryRequestRef.current) return;
      setSummaryLoading(false);
      if (response.status === 200) {
        setEventTypes(selectAuditSummary(response.data, typeDetected));
      } else {
        setSummaryError('Unable to load event counts. Please try again.');
      }
    }).catch((error) => {
      if (requestId !== summaryRequestRef.current) return;
      console.error('Unable to load event counts:', error);
      setSummaryLoading(false);
      setSummaryError('Unable to load event counts. Please try again.');
    });
  }

  const handleExport = () => {

    const clientname = localStorage.getItem('displayname');
    ////
    setOpenAuto(false)
    setErrorFromdate('')
    setErrorTodate('')
    // console.log(fromDate,toDate);
    const isValidDate = (dateString) => {
      const parsedDate = dayjs(dateString, 'YYYY-MM-DD HH:mm:ss', true);
      return parsedDate.isValid();
    };

    if (fromDate === null && toDate === null) {
      return;
    }

    const fromdDateObj = isValidDate(fromDate)
    const toDateObj = isValidDate(toDate)

    if (!fromdDateObj) setErrorFromdate('Select Valid From Date')
    if (!toDateObj) setErrorTodate('Select Valid To Date')
    const filteredData = alldata.filterData; // Use your fetched data here.
    //  console.log("fiterdat ==",filteredData);

    if (filteredData.length === 0) {
      alert('No data available to export.');
      return;
    }

    // Prepare data for export
    const exportData = filteredData.map((item, index) => ({
      "S.NO": index + 1,
      "Camera Name": item.devicename || 'N/A',
      // "Detect Type": item. || 'N/A',
      "Event Type": item.DetectedType || 'N/A',
      "Event Time": item.EventTime ? dayjs(item.EventTime).format('YYYY-MM-DD HH:mm:ss') : 'N/A',
      "Video URL": item.VideoUrl || 'N/A',
    }));

    // Create a worksheet and workbook
    const worksheet = XLSX.utils.json_to_sheet(exportData);

    // Adjust column widths based on data
    const columnWidths = [
      { wch: 5 },  // S.NO
      { wch: 20 }, // Camera Name
      { wch: 15 }, // Event Type
      { wch: 20 }, // Event Time
      { wch: 40 }, // Video URL
    ];
    worksheet['!cols'] = columnWidths;

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Audit Data');

    // Export to Excel
    XLSX.writeFile(workbook, `${clientname}_Report_${dayjs().format('YYYY-MM-DD_HH-mm-ss')}.xlsx`);


  }

  //Date block
  //const today = new Date();

  const today = calculatedDay ? calculatedDay.toDate() : new Date();
  const [startDate, setStartDate] = useState(null)
  useEffect(() => {
    let active = true;
    const fetchData = async () => {
      try {
        const clientNow = await getCurrentClientNow(localStorage.getItem('client_type'));
        if (active) setCalculatedDay(clientNow.startOf('day'));
      } catch (error) {
        console.error("Error resolving client timezone:", error);
        if (active) setCalculatedDay(dayjs().startOf('day'));
      }
    };

    fetchData();
    return () => {
      active = false;
      summaryRequestRef.current += 1;
    };
  }, []);

  const getAllDates = () => {
    const allDates = [];
    const baseDate = calculatedDay ? calculatedDay.toDate() : new Date();
    const earliestDate = new Date(baseDate);
    earliestDate.setDate(baseDate.getDate() - 89); // 90 days back
    for (let i = 0; i < 90; i++) {
      const newDate = new Date(earliestDate);
      newDate.setDate(earliestDate.getDate() + i);
      allDates.push(newDate);
    }
    return allDates;
  };
  // Calculate the index of today in allDates
  const allDates = getAllDates();
  //const [allDates,setAllDates] = useState([])

  const todayIndex = allDates.findIndex(
    (date) =>
      date.getDate() === (calculatedDay ? calculatedDay.date() : new Date().getDate()) &&
      date.getMonth() === (calculatedDay ? calculatedDay.month() : new Date().getMonth()) &&
      date.getFullYear() === (calculatedDay ? calculatedDay.year() : new Date().getFullYear())
  );
  //console.log('todayIndex',todayIndex)
  const [selectedDateIndex, setSelectedDateIndex] = useState(todayIndex);


  const formatDate = (date) => {
    const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    return `${days[date.getDay()]}, ${date.getDate()} ${date.toLocaleString('default', { month: 'short' })}`;
  };



  const formatSelectedDate = (date) => {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };
  // Get dates to display (8 initially, 7 for previous)

  useEffect(() => {
    //const isNavigated = (filterData === null || filterData === undefined) ? false : true;
    //setIsDateAvail(true)
    if (calculatedDay) {
      setIsDateAvail(true);
      const initialStart = calculatedDay ? calculatedDay.toDate() : new Date(today);
      initialStart.setDate(initialStart.getDate() - 14);
      setStartDate(initialStart);
      setSelectedDateIndex(89);
      // const dates = getDates(initialStart);
      // setDates(dates);
    }
  }, [calculatedDay]);

  useEffect(() => {
    if (startDate) {
      const newDates = getDates(startDate);
      setDates(newDates);
    }
  }, [startDate]);

  const getDates = (start) => {
    const dates = [];
    if (start) {
      const maxDays = 15;
      // const maxDays = start.getDate() === today.getDate() - 7 ? 8 : 7; // 8 for initial, 7 for prev
      for (let i = 0; i < maxDays; i++) {
        const newDate = new Date(start);
        newDate.setDate(start.getDate() + i);
        if (newDate <= today) {
          dates.push(newDate);
        } else {
          break;
        }
      }
    }
    return dates;
  };
  //const dates = getDates(startDate);
  const [dates, setDates] = useState([])
  const handlePrev = () => {

    const newStart = new Date(startDate);
    newStart.setDate(startDate.getDate() - 15); // Go back 5 days
    setStartDate(newStart);
  };
  const handleNext = () => {
    const newStart = new Date(startDate);
    newStart.setDate(startDate.getDate() + 15); // Go forward 5 days
    setStartDate(newStart);
  };
  const handleDateClick = (index) => {
    const clickedDate = dates[index];
    const newIndex = allDates.findIndex(
      (date) =>
        date.getDate() === clickedDate.getDate() &&
        date.getMonth() === clickedDate.getMonth() &&
        date.getFullYear() === clickedDate.getFullYear()
    );
    setSelectedDateIndex(newIndex);
    clearFilterData();
  };
  const isNextDisabled = () => {
    if (!calculatedDay || !dates.length) return true;
    const lastDisplayedDate = dates[dates.length - 1];
    return (
      lastDisplayedDate.getDate() === calculatedDay.date() &&
      lastDisplayedDate.getMonth() === calculatedDay.month() &&
      lastDisplayedDate.getFullYear() === calculatedDay.year()
    );
  };
  const isPrevDisabled = () => {
    if (!calculatedDay || !dates.length) return true;
    const firstDisplayedDate = dates[0];
    const earliestDate = new Date(calculatedDay.toDate());
    earliestDate.setDate(calculatedDay.date() - 89);
    return (
      firstDisplayedDate.getDate() === earliestDate.getDate() &&
      firstDisplayedDate.getMonth() === earliestDate.getMonth() &&
      firstDisplayedDate.getFullYear() === earliestDate.getFullYear()
    );
  };

  const formatSelectedDateRange = (date) => {
    if (!date) return null;
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const fromDate = `${year}-${month}-${day} 00:00:00`;
    const toDate = `${year}-${month}-${day} 23:59:59`;
    return { fromDate, toDate };
  };

  const selectedDateRange =
    selectedDateIndex !== -1 && allDates[selectedDateIndex]
      ? formatSelectedDateRange(allDates[selectedDateIndex])
      : null;
  //console.log(selectedDateRange)

  const lastSiteTypeRef = useRef(siteType);
  const navigationFromDate = parseAuditDate(initialFromDate)?.format('YYYY-MM-DD HH:mm:ss');
  const navigationToDate = parseAuditDate(initialToDate)?.format('YYYY-MM-DD HH:mm:ss');
  const getActiveAuditRange = () => {
    if (!calculatedDay || !selectedDateRange) return null;
    return {
      fromDate: navigationFromDate || selectedDateRange.fromDate,
      toDate: navigationToDate || selectedDateRange.toDate,
      locationId: Number(initialLocation ?? selectedLocation ?? 0),
      propertyId: initialProperty ?? selectedProperty,
    };
  };

  useEffect(() => {
    const siteTypeChanged = lastSiteTypeRef.current !== siteType;
    lastSiteTypeRef.current = siteType;

    // a category change drops the dashboard card filter and falls back to the
    // current day, the effect reruns once isNavigated turns false
    if (isNavigated && siteTypeChanged) {
      setSelectedDateIndex(todayIndex);
      clearFilterData();
      return;
    }

    const range = getActiveAuditRange();
    if (!range) return undefined;
    // Fetch both endpoints with the same resolved filters. Audit loading never
    // waits for the summary callback, and every navigation starts a new request.
    handlerGetFilterData(range);
    getCardsData();
    setSelectedCard(typeDetected || 'total');
    return () => { summaryRequestRef.current += 1; };
  }, [selectedDateRange?.fromDate, selectedDateRange?.toDate, calculatedDay, navigationFromDate, navigationToDate, typeDetected, isNavigated, initialLocation, initialProperty, selectedLocation, selectedProperty, siteType]);


  //Camera drop down


  const anchorRef = useRef(null);

  const options = clientGroupList.length > 0 ? camerasByGroupId : cameras;

  const loadIndividualEvents = (type) => {
    setEventName(type);
    navigate('/escalatedEventsUS', {
      state: { filterData: { fromDate, toDate, eventType: type } },
    });
  }


  const [liked, setLiked] = useState(false);

  const locationsChange = (e, value) => {
    const val = e.target.value;
    setSelectedLocation(val);
    localStorage.setItem('selectedLocation', val)
    clearFilterData();
    //handleGet()
  }

  const propertyChange = (e, value) => {
    const val = e.target.value;
    setSelectedProperty(val);
    localStorage.setItem('selectedProperty', val)
    clearFilterData();
    //handleGet()
  }

  return (
    <Page title="Escalated Events">
      <Container maxWidth="xxl" sx={{p:0}}>
        <NotificationAlert
          open={alertStatus.open}
          handleClose={handleNotificationBar}
          title={alertStatus.title}
          description={alertStatus.description} />

        {/* ── Page Header ── */}
        <Box sx={{ mb: 4 }}>
          <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
            {agentBased === '0' ?
              <Typography variant="h4">Audits</Typography> :
              <Typography variant="h4">Escalated Events</Typography>
            }
          </Box>
          <Breadcrumbs separator="•" aria-label="breadcrumb">
            <DashboardBreadcrumbLink sx={{ fontSize: '0.875rem' }} />
            <Typography color="text.primary" sx={{ fontSize: '0.875rem' }}>
              {agentBased === '0' ? 'Audits' : 'Escalated Events'}
            </Typography>
          </Breadcrumbs>
          {Number(userType) === 33 && (
            <Typography sx={{ fontWeight: 800, mt: 0.5 }}>Note: Monitoring hours - 10 PM to 6 AM</Typography>
          )}
        </Box>

        {!isDateAvail ?
          (<Box sx={{ display: "flex", alignItems: "center", mt: 2 }}>
            <CircularProgress sx={{ marginLeft: '45%' }} />
          </Box>) :
          (<Card sx={{ mt: 0 }}>

            {/* ── Toolbar Row ── */}
            <Box sx={{ px: 2, pt: 2, pb: 1.5 }}>
              <Grid container alignItems="center" spacing={1.5} wrap="wrap">

                {/* Property dropdown */}
                {properties.length > 1 && (
                  <Grid item>
                    <FormControl size="small" sx={{ width: 200 }}>
                      <InputLabel>Location</InputLabel>
                      <Select
                        value={selectedProperty || ''}
                        label="Location"
                        onChange={propertyChange}
                      >
                        {properties.map((event) => (
                          <MenuItem key={event.ID} value={event.ID}>
                            {event.Location}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                )}

                {/* Location dropdown */}
                {(clientType === "INDIA" || client_id === "1316") && locations.length > 1 && (
                  <Grid item>
                    <FormControl size="small" sx={{ width: 200 }}>
                      <InputLabel>Location</InputLabel>
                      <Select
                        value={selectedLocation || ''}
                        label="Location"
                        onChange={locationsChange}
                      >
                        {locations.map((event) => (
                          <MenuItem key={event.Id} value={event.Id}>
                            {event.LocationName}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                )}

                {/* Date Navigation */}
                <Grid item xs={12} md>
                  <NavButtonContainer>
                    <NavButton onClick={handlePrev} disabled={isPrevDisabled()}>
                      {'<'}
                    </NavButton>

                    <DateRow>
                      {dates.map((date, index) => {
                        const globalIndex = allDates.findIndex(
                          (d) =>
                            d.getDate() === date.getDate() &&
                            d.getMonth() === date.getMonth() &&
                            d.getFullYear() === date.getFullYear()
                        );

                        const parsedDate = new Date(date);
                        const month = parsedDate.toLocaleString('en-US', { month: 'short' });
                        const dayNumber = parsedDate.getDate();
                        const dayName = parsedDate.toLocaleString('en-US', { weekday: 'short' });

                        const dateSelected = globalIndex === selectedDateIndex && !isNavigated;

                        return (
                          <DateBox
                            key={index}
                            dateSelected={dateSelected}
                            onClick={() => handleDateClick(index)}
                          >
                            <DateText>
                              <MonthText>{month}</MonthText>
                              <DayNumber>{dayNumber}</DayNumber>
                              <DayText>{dayName}</DayText>
                            </DateText>
                          </DateBox>
                        );
                      })}
                    </DateRow>

                    <NavButton onClick={handleNext} disabled={isNextDisabled()}>
                      {'>'}
                    </NavButton>
                  </NavButtonContainer>
                </Grid>

                {/* Search + Filter */}
                <Grid item xs={12} md="auto">
                  <Box display="flex" alignItems="center" gap={1}>
                    <SearchStyle
                      onChange={onFilterAudits}
                      sx={{ minWidth: 200 }}
                      placeholder="Search..."
                      startAdornment={
                        <InputAdornment position="start">
                          <Iconify
                            icon="eva:search-fill"
                            sx={{ color: 'text.disabled', width: 20, height: 20 }}
                          />
                        </InputAdornment>
                      }
                    />
                    <Tooltip title="Filter Cameras">
                      <IconButton ref={anchorRef} onClick={() => setOpen((prev) => !prev)}>
                        <FilterListIcon />
                      </IconButton>
                    </Tooltip>
                  </Box>
                </Grid>
              </Grid>
            </Box>

            {/* ── Filter Popper ── */}
            <Popper
              open={open}
              anchorEl={anchorRef.current}
              placement="bottom-end"
              style={{ zIndex: 1300 }}
            >
              <Paper
                elevation={4}
                sx={{
                  px: 2,
                  py: 1.5,
                  borderRadius: 3,
                  maxWidth: 540,
                  width: '100%',
                  boxShadow: 3,
                  mt: 1,
                }}
              >
                <Box display="flex" flexWrap="wrap" alignItems="center" gap={2}>

                  {/* Detected Types */}
                  {agentBased === '0' && (
                    <Box sx={{ minWidth: 180, flexGrow: 1 }}>
                      <Autocomplete
                        multiple
                        options={analytics}
                        value={detectedType}
                        getOptionLabel={(option) => option.Name}
                        onChange={handleDetectedType}
                        sx={{ '& .MuiOutlinedInput-root': { height: 40, backgroundColor: UI.inputBg } }}
                        ListboxProps={{ sx: { bgcolor: 'background.paper', color: 'text.primary' } }}
                        renderInput={(params) => (
                          <TextField {...params} size="small" placeholder="Types" />
                        )}
                        renderOption={(props, option) => (
                          <Box component="li" {...props} key={option.Name}>{option.Name}</Box>
                        )}
                        filterSelectedOptions
                      />
                    </Box>
                  )}

                  {/* Groups */}
                  {clientGroupList.length > 0 && (
                    <Box sx={{ minWidth: 180, flexGrow: 1 }}>
                      <Autocomplete
                        multiple
                        options={clientGroupList}
                        value={[]}
                        disableCloseOnSelect
                        isOptionEqualToValue={(option, value) => option.GroupId === value.GroupId}
                        filterOptions={handleGroupFilterOptions}
                        onChange={handleGroupChange}
                        sx={{ '& .MuiOutlinedInput-root': { height: 40, backgroundColor: UI.inputBg } }}
                        ListboxProps={{ sx: { bgcolor: 'background.paper', color: 'text.primary' } }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            size="small"
                            placeholder="Groups"
                            sx={{
                              '& .MuiInputBase-input': { color: UI.inputText },
                              '& .MuiInputBase-input::placeholder': { color: theme.palette.text.secondary, opacity: 1 },
                              '& .MuiOutlinedInput-notchedOutline': { borderColor: UI.inputBorder },
                            }}
                          />
                        )}
                        renderOption={(props, option) => (
                          <li {...props}>
                            {option.all ? (
                              <>
                                <Checkbox icon={groupicon} checkedIcon={groupcheckedIcon} style={{ marginRight: 8 }} checked={groupCheckValue} />
                                {option.title}
                              </>
                            ) : (
                              <>
                                <Checkbox
                                  icon={icon}
                                  checkedIcon={checkedIcon}
                                  style={{ marginRight: 8 }}
                                  checked={activeGroups.includes(option.GroupId)}
                                  onChange={() => {
                                    const isChecked = activeGroups.includes(option.GroupId);
                                    const newActiveGroups = isChecked
                                      ? activeGroups.filter((id) => id !== option.GroupId)
                                      : [...activeGroups, option.GroupId];
                                    setActiveGroups(newActiveGroups);
                                  }}
                                />
                                {option.GroupName}
                              </>
                            )}
                          </li>
                        )}
                      />
                    </Box>
                  )}

                  {/* Cameras */}
                  <Box sx={{ minWidth: 300, flexGrow: 1 }}>
                    <Autocomplete
                      multiple
                      disableCloseOnSelect
                      options={options}
                      value={[]}
                      getOptionLabel={(option) => option.selectall ? 'Select All' : `${option.deviceid} ${option.devicename}`}
                      onChange={handleCamerasChange}
                      sx={{ '& .MuiOutlinedInput-root': { height: 40, backgroundColor: UI.inputBg } }}
                      ListboxProps={{ sx: { bgcolor: 'background.paper', color: 'text.primary' } }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          size="small"
                          placeholder="Cameras"
                          sx={{
                            '& .MuiInputBase-input': { color: UI.inputText },
                            '& .MuiInputBase-input::placeholder': { color: theme.palette.text.secondary, opacity: 1 },
                            '& .MuiOutlinedInput-notchedOutline': { borderColor: UI.inputBorder },
                          }}
                        />
                      )}
                      renderOption={(props, option) => (
                        <li {...props}>
                          {option.selectall ? (
                            <>
                              <Checkbox icon={icon} checkedIcon={checkedIcon} style={{ marginRight: 8 }} checked={checkValue} />
                              {option.title}
                            </>
                          ) : (
                            <>
                              <Checkbox
                                icon={icon}
                                checkedIcon={checkedIcon}
                                style={{ marginRight: 8 }}
                                checked={activeCameras.includes(option.uid)}
                                onChange={() => {
                                  const isChecked = activeCameras.includes(option.uid);
                                  const newActiveCameras = isChecked
                                    ? activeCameras.filter((uid) => uid !== option.uid)
                                    : [...activeCameras, option.uid];
                                  setActiveCameras(newActiveCameras);
                                }}
                              />
                              {`${option.devicename}`}
                            </>
                          )}
                        </li>
                      )}
                      filterOptions={handleFilterOptions}
                    />
                  </Box>

                  {/* Action Buttons */}
                  <Box sx={{ ml: 'auto', display: 'flex', gap: 1 }}>
                    <Tooltip
                      title={activeCameras.length === 0 ? 'Please select at least one camera' : ''}
                      disableHoverListener={activeCameras.length > 0}
                      arrow
                    >
                      <span>
                        <IconButton
                          size="small"
                          disabled={activeCameras.length === 0}
                          sx={{
                            px: 2,
                            borderRadius: 2,
                            height: 40,
                            bgcolor: activeCameras.length === 0 ? theme.palette.action.disabledBackground : 'primary.main',
                            color: activeCameras.length === 0 ? theme.palette.text.disabled : theme.palette.primary.contrastText,
                            fontWeight: 'bold',
                            '&:hover': {
                              bgcolor: activeCameras.length === 0 ? theme.palette.action.disabledBackground : theme.palette.primary.dark,
                            },
                            cursor: activeCameras.length === 0 ? 'not-allowed' : 'pointer',
                            opacity: 1,
                            boxShadow: activeCameras.length === 0 ? `inset 0 0 0 1px ${UI.inputBorder}` : 3,
                            transition: 'background-color 0.3s ease',
                          }}
                          onClick={() => {
                            if (activeCameras.length > 0) {
                              setOpen(false);
                              handleGet();
                            }
                          }}
                        >
                          <Typography fontWeight="bold">Get</Typography>
                        </IconButton>
                      </span>
                    </Tooltip>

                    <IconButton
                      size="small"
                      sx={{
                        bgcolor: 'error.main',
                        px: 2,
                        borderRadius: 2,
                        height: 40,
                        '&:hover': { bgcolor: 'error.light' },
                      }}
                      onClick={() => setOpen(false)}
                    >
                      <Typography fontWeight="bold" color="#ffffff">Close</Typography>
                    </IconButton>
                  </Box>

                </Box>
              </Paper>
            </Popper>

            {/* ── Event Type Cards ── */}
            {agentBased === '1' && (
              <>
                <Divider sx={{ mx: 2 }} />
                <Box sx={{ px: 2, py: 1.5 }}>
                  <Grid container spacing={1} alignItems="center">
                    {/* Total Events Card */}
                    {!typeDetected && (
                      <Grid item>
                        <Card
                          onClick={() => {
                            setSelectedCard('total');
                            setEventName('');
                            handleDetectedType(null, []);
                            filterAudits('', 'search');
                          }}
                          sx={{
                            backgroundColor: selectedCard === 'total' ? theme.palette.primary.main : UI.chipMutedBg,
                            color: selectedCard === 'total' ? theme.palette.primary.contrastText : UI.chipMutedText,
                            border: selectedCard === 'total'
                              ? `2px solid ${alpha(theme.palette.primary.main, 0.6)}`
                              : `1px solid ${UI.inputBorder}`,
                            borderRadius: 2,
                            minWidth: 130,
                            height: 60,
                            px: 1.5,
                            py: 1,
                            boxShadow: selectedCard === 'total'
                              ? `0 2px 8px ${alpha(theme.palette.primary.main, 0.3)}`
                              : `0 1px 3px ${alpha(theme.palette.common.black, isDark ? 0.4 : 0.08)}`,
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease-in-out',
                            '&:hover': {
                              transform: 'translateY(-2px)',
                              boxShadow: `0 4px 10px ${alpha(theme.palette.primary.main, 0.2)}`,
                            },
                          }}
                        >
                          <Typography variant="subtitle1" fontWeight="bold">
                            {summaryLoading ? 'Loading…' : summaryError ? 'Unavailable' : eventTypes.reduce((sum, item) => sum + Number(item.Count || 0), 0)}
                          </Typography>
                          <Typography variant="caption" sx={{ mt: 0.2, opacity: 0.9 }}>
                            Total Events
                          </Typography>
                        </Card>
                      </Grid>
                    )}

                    {/* Individual Event Type Cards */}
                    {!summaryLoading && !summaryError && eventTypes.filter(item => item.Count > 0).map((item, i) => (
                      <Grid item key={i}>
                        <Card
                          onMouseEnter={() => setHoveredIndex(i)}
                          onMouseLeave={() => setHoveredIndex(null)}
                          onClick={() => {
                            setSelectedCard(item.Type);
                            setEventName(item.Type);
                            handleDetectedType(null, [{ Id: item.Type, Name: item.Type }]);
                            filterAudits(item.Type, 'detectedType');
                          }}
                          sx={{
                            backgroundColor:
                              selectedCard === item.Type || hoveredIndex === i ? theme.palette.primary.main : UI.chipMutedBg,
                            color:
                              selectedCard === item.Type || hoveredIndex === i ? theme.palette.primary.contrastText : UI.chipMutedText,
                            border: selectedCard === item.Type
                              ? `2px solid ${alpha(theme.palette.primary.main, 0.6)}`
                              : `1px solid ${UI.inputBorder}`,
                            borderRadius: 2,
                            minWidth: 130,
                            height: 60,
                            px: 1.5,
                            py: 1,
                            boxShadow:
                              selectedCard === item.Type || hoveredIndex === i
                                ? `0 2px 8px ${alpha(theme.palette.primary.main, 0.3)}`
                                : `0 1px 3px ${alpha(theme.palette.common.black, isDark ? 0.4 : 0.08)}`,
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease-in-out',
                            '&:hover': {
                              transform: 'translateY(-2px)',
                              boxShadow: `0 4px 10px ${alpha(theme.palette.primary.main, 0.2)}`,
                            },
                          }}
                        >
                          <Box display="flex" alignItems="center" justifyContent="space-between">
                            <Typography
                              variant="subtitle1"
                              fontWeight="bold"
                              sx={{
                                color: selectedCard === item.Type || hoveredIndex === i ? theme.palette.primary.contrastText : UI.chipMutedText,
                              }}
                            >
                              {item.Count}
                            </Typography>
                            <Box
                              component="img"
                              src={item.Icon}
                              alt={item.Type}
                              sx={{
                                width: 20,
                                height: 20,
                                opacity: selectedCard === item.Type || hoveredIndex === i ? 0.9 : 0.75,
                                filter:
                                  selectedCard === item.Type || hoveredIndex === i
                                    ? 'brightness(0) invert(1)'
                                    : 'brightness(0) saturate(100%) invert(70%) sepia(10%) saturate(600%) hue-rotate(180deg) brightness(100%) contrast(90%)',
                                transition: 'filter 0.2s ease-in-out, opacity 0.2s ease-in-out',
                              }}
                            />
                          </Box>
                          <Typography
                            variant="caption"
                            sx={{
                              mt: 0.2,
                              color: selectedCard === item.Type || hoveredIndex === i ? theme.palette.primary.contrastText : UI.chipMutedText,
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                            }}
                          >
                            {item.Type}
                          </Typography>
                        </Card>
                      </Grid>
                    ))}
                  </Grid>
                </Box>
              </>
            )}

            <Divider />
            {summaryError && <Typography color="error" sx={{ px: 2, py: 1 }}>{summaryError}</Typography>}

            {/* ── Event List ── */}
            <Box sx={{ p: 2 }}>
              {alldata.isLoad ? (
                <Box sx={{ display: "flex", alignItems: "center", py: 4 }}>
                  <CircularProgress sx={{ mx: 'auto' }} />
                </Box>
              ) : alldata.filterData.length === 0 ? (
                <Box sx={{ width: '100%', py: 4 }}>
                  <Typography variant="body1" align="center" fontWeight="bold" color="text.secondary">
                    No data
                  </Typography>
                </Box>
              ) : (
                <AuditList
                  cameras={cameras}
                  audits={alldata.filterData}
                  loadMoreAudits={loadMoreAudits}
                  updateToClient={updateToClient}
                  isEscalating={isEscalating}
                  clientId={clientId}
                  getCardsData={getCardsData}
                  displayDialog={displayDialog}
                />
              )}
            </Box>
          </Card>)}


        {/* audit player */}
        {(player.isOpen || showDialog.isOpen) && (
          <AuditPlayer
            player={player.event ? player.event : showDialog.event}
            setPlayer={player.event ? setPlayer : setShowDialog}
            updateToClient={updateToClient}
            isEscalating={isEscalating}
            clientId={clientId}
          />
        )}

      </Container>
    </Page>
  );
}
